import type { FC } from 'react';

import AuditLogsProvider from '@zen/Audit/AuditLogsProvider';
import RoleProvider from '@zen/Auth/RoleProvider';
import UserDataProvider from '@zen/Auth/UserDataProvider';
import { VisitedAccountsProvider } from '@zen/Components/VisitedAccounts';

import Dashboard from './Dashboard';

const DashboardContainer: FC = () => {
  return (
    <VisitedAccountsProvider>
      <UserDataProvider>
        <RoleProvider>
          <AuditLogsProvider>
            <Dashboard />
          </AuditLogsProvider>
        </RoleProvider>
      </UserDataProvider>
    </VisitedAccountsProvider>
  );
};

export default DashboardContainer;
